<script lang="ts">
    import CN from "classnames";

    let className = "";
    export { className as class };

    export let href: string | null = null;
    export let disabled = false;
    export let type: "button" | "submit" | "reset" = "button";
    export let target: "_self" | "_blank" | "_parent" | "_top" | null = null;
    export let rel: string | null = null;
    export let role: string | null = null;

    export let withoutReset = false;

    export let ariaLabel: string | null = null;
    export let ariaPressed: boolean | null = null;
    export let ariaExpanded: boolean | null = null;
    export let ariaControls: string | null = null;
    export let ariaSelected: boolean | null = null;
    export let ariaBusy: boolean | null = null;

    $: classes = CN(
        "gw-unstyled-btn",
        {
            "gw-unstyled-btn--reset": !withoutReset,
        },
        className
    );

    const isLink = !!href;
    const tag = isLink ? "a" : "button";
</script>

<svelte:element
    this={tag}
    href={isLink && !disabled ? href : undefined}
    type={!isLink ? type : undefined}
    target={isLink ? target : undefined}
    rel={isLink ? rel : undefined}
    {role}
    disabled={!isLink ? disabled : undefined}
    tabindex={isLink && disabled ? -1 : undefined}
    aria-disabled={disabled ? true : undefined}
    aria-label={ariaLabel}
    aria-pressed={!isLink ? ariaPressed : undefined}
    aria-expanded={ariaExpanded}
    aria-controls={ariaControls}
    aria-busy={ariaBusy ? true : undefined}
    aria-selected={ariaSelected}
    class={classes}
    on:click
    on:mouseover
    on:focus
    on:mousedown
    on:mouseup
    on:mouseleave
    on:blur
    {...$$restProps}
>
    <slot />
</svelte:element>

<style lang="postcss" global>
    .gw-unstyled-btn--reset {
        min-width: unset;
        min-height: unset;
        font-family: inherit;
        margin: 0;
        padding: 0;
        border: none;
        cursor: pointer;
        background: transparent;
        font-size: inherit;
        color: inherit;
        text-decoration: none;
    }
</style>
